var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { align: "baseline" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c("v-autocomplete", {
            attrs: {
              label: _vm.select_label,
              hint: _vm.hint,
              "persistent-hint": _vm.hint ? true : false,
              items: _vm.reserves,
              readonly: _vm.readonly,
              chips: "",
              "deletable-chips": "",
              "item-text": "name",
              "return-object": "",
              multiple: "",
            },
            on: {
              change: function ($event) {
                return _vm.$emit("change")
              },
            },
            model: {
              value: _vm.participating,
              callback: function ($$v) {
                _vm.participating = $$v
              },
              expression: "participating",
            },
          }),
        ],
        1
      ),
      _vm._l(_vm.filteredParticipating, function (reserve) {
        return _c(
          "v-col",
          { key: reserve.id },
          [
            _c("v-text-field", {
              staticClass: "py-0 mx-2",
              attrs: {
                "error-messages": _vm.$utils.getIfExists(_vm.errorMessages, [
                  reserve.id,
                  "messages",
                ]),
                label: reserve.name + " " + _vm.label,
                suffix: _vm.suffix,
                type: _vm.type,
                readonly: _vm.readonly,
              },
              on: {
                change: function ($event) {
                  return _vm.$emit("change")
                },
              },
              model: {
                value: _vm.computedValue[reserve.id],
                callback: function ($$v) {
                  _vm.$set(_vm.computedValue, reserve.id, _vm._n($$v))
                },
                expression: "computedValue[reserve.id]",
              },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }